import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, } from 'swiper/core';
import { Box } from '@waglabs/box-next';
import { Flex } from '@waglabs/flex-next';
import { useGetResponsivePropValue } from '@waglabs/use-get-responsive-prop-value';
import { ReviewCarouselItem } from './components/ReviewCarouselItem';
export const mobileSwiperParams = {
    freeMode: true,
    slidesOffsetBefore: 8,
    spaceBetween: 8,
    width: 264,
    slidesPerView: 1.1,
};
export const desktopSwiperParams = {
    autoHeight: true,
    slidesPerView: 1,
    grabCursor: true,
    loop: false,
    loopFillGroupWithBlank: true,
    pagination: {
        clickable: true,
        el: '.swiper-pagination-custom',
        type: 'bullets',
    },
    spaceBetween: 16,
};
SwiperCore.use([Pagination]);
export const ReviewCarousel = ({ reviews, containerProps, swiperParams = [mobileSwiperParams, desktopSwiperParams], }) => {
    const swiperProps = useGetResponsivePropValue(swiperParams);
    return (React.createElement(Box, Object.assign({}, containerProps),
        React.createElement(SwiperGlobalStyle, null),
        React.createElement(Swiper, Object.assign({}, swiperProps),
            reviews.map((review) => (React.createElement(SwiperSlide, { key: review.author + review.title },
                React.createElement(ReviewCarouselItem, { key: review.author + review.title, src: review.src, author: review.author, body: review.body, title: review.title })))),
            React.createElement(Flex, { className: "swiper-pagination-custom", display: ['none', null, 'flex'], alignItems: "center", justifyContent: "center", my: 1 }))));
};
const SwiperGlobalStyle = createGlobalStyle `
  .swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
  }
  .swiper-pagination-bullet.swiper-pagination-bullet-active {
    background-color: #00BF8F;
    width: 12px;
    height: 12px;
  }
`;
